export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  subscribe: {
    path: '/subscribe',
    getHref: () => '/subscribe',
  },

  auth: {
    login: {
      path: '/auth/login',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
    register: {
      path: '/auth/register',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/register${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
    verifyEmail: {
      path: '/auth/verify-email',
      getHref: () => '/auth/verify-email',
    },
    resetPassword: {
      path: '/auth/reset-password',
      getHref: () => '/auth/reset-password',
    },
    newPassword: {
      path: '/auth/new-password',
      getHref: () => '/auth/new-password',
    },
    manageAccount: {
      path: '/auth/manageAccount',
      getHref: () => '/auth/manageAccount',
    },
    revertMfa: {
      path: '/auth/revert-mfa',
      getHref: () => '/auth/revert-mfa',
    },
  },

  app: {
    root: {
      path: '/',
      getHref: () => '/',
    },
    dashboard: {
      path: '',
      getHref: () => '/',
    },
    agents: {
      path: 'agents',
      getHref: () => '/agents',
      create: {
        path: 'agents/create',
        getHref: () => '/agents/create',
      },
    },
    agent: {
      path: 'agents/:agentId',
      getHref: (id: string) => `/agents/${id}`,
    },
    avatars: {
      path: 'avatars',
      getHref: () => '/avatars',
      create: {
        path: 'avatars/create',
        getHref: () => '/avatars/create',
      },
    },
    videos: {
      path: 'videos',
      getHref: () => '/videos',
      create: {
        path: 'videos/create',
        getHref: () => '/videos/create',
      },
    },
    conversations: {
      path: 'conversations',
      getHref: () => '/conversations',
    },
    conversation: {
      path: 'conversations/:conversationId',
      getHref: (id: string) => `/conversations/${id}`,
    },
    knowledge: {
      path: 'knowledge',
      getHref: () => '/knowledge',
    },
    analytics: {
      path: 'analytics',
      getHref: () => '/analytics',
    },
    invite: {
      path: 'invites/:inviteId',
      getHref: (id: string) => `/invites/${id}`,
    },
    billing: {
      path: 'billing',
      getHref: () => '/billing',
    },
    settings: {
      path: 'settings',
      getHref: () => '/settings',
      branding: {
        path: 'branding',
        getHref: () => '/settings/branding',
      },
      members: {
        path: 'members',
        getHref: () => '/settings/members',
      },
      subscription: {
        path: 'subscription',
        getHref: () => '/settings/subscription',
      },
      invoices: {
        path: 'invoices',
        getHref: () => '/settings/invoices',
      },
      apiKeys: {
        path: 'api-keys',
        getHref: () => '/settings/api-keys',
      },
      webhooks: {
        path: 'webhooks',
        getHref: () => '/settings/webhooks',
      },
    },
  },
} as const;
